/* lrfr landing page: load videos only near the viewport, pause them off-screen,
   and auto-advance the hero video strip while it is visible and untouched. */
(function () {
  if (window.__lrfr) return;
  window.__lrfr = true;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  // A video with a src delays the window load event, which would hold back
  // everything the theme defers to load. Show posters early, fetch video after.
  var loaded = document.readyState === 'complete';
  var waiting = [];
  if (!loaded) {
    window.addEventListener('load', function () {
      loaded = true;
      waiting.forEach(function (v) { if (v.__lrfrVisible) playable(v); });
      waiting = [];
    }, { once: true });
  }

  function playable(v) {
    if (!v.getAttribute('poster') && v.dataset.poster) {
      v.poster = v.dataset.poster;
    }
    if (!loaded) {
      if (waiting.indexOf(v) < 0) waiting.push(v);
      return;
    }
    if (!v.getAttribute('src') && v.dataset.src) {
      v.src = v.dataset.src;
    }
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function initVideos() {
    var vids = document.querySelectorAll('video[data-lrfr-video]');
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { if (v.dataset.poster) v.poster = v.dataset.poster; v.src = v.dataset.src; if (!reduce) playable(v); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        v.__lrfrVisible = e.isIntersecting;
        if (e.isIntersecting) {
          if (reduce) {
            if (v.dataset.poster) v.poster = v.dataset.poster;
            if (!v.getAttribute('src') && loaded) { v.preload = 'metadata'; v.src = v.dataset.src; }
          } else {
            playable(v);
          }
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { rootMargin: '200px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  }

  function initStrips() {
    if (reduce) return;
    var strips = document.querySelectorAll('[data-lrfr-auto]');
    if (!strips.length) return;
    // Programmatic scrolling fires trusted scroll events, which the theme treats
    // as a first interaction and uses to release held third-party apps. So
    // auto-advance only after the visitor has actually interacted.
    var GESTURES = ['pointerdown', 'touchstart', 'keydown', 'wheel', 'scroll'];
    function start(e) {
      if (e && e.isTrusted === false) return;
      GESTURES.forEach(function (n) { window.removeEventListener(n, start, true); });
      strips.forEach(autoAdvance);
    }
    GESTURES.forEach(function (n) { window.addEventListener(n, start, { capture: true, passive: true }); });
  }

  function autoAdvance(strip) {
    if (strip.__lrfrAuto) return;
    strip.__lrfrAuto = true;
    (function () {
      var visible = false;
      var held = false;
      var timer = null;
      var resume = null;
      function hold() {
        held = true;
        clearTimeout(resume);
        resume = setTimeout(function () { held = false; }, 6000);
      }
      ['pointerdown', 'wheel', 'touchstart', 'focusin', 'mouseenter'].forEach(function (ev) {
        strip.addEventListener(ev, hold, { passive: true });
      });
      strip.addEventListener('mouseleave', function () { held = false; });
      function step() {
        if (!visible || held || document.hidden) return;
        var item = strip.firstElementChild;
        if (!item) return;
        var gap = parseFloat(getComputedStyle(strip).columnGap) || 0;
        var max = strip.scrollWidth - strip.clientWidth;
        if (strip.scrollLeft >= max - 4) {
          strip.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          strip.scrollBy({ left: item.offsetWidth + gap, behavior: 'smooth' });
        }
      }
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible && !timer) timer = setInterval(step, 2800);
        if (!visible && timer) { clearInterval(timer); timer = null; }
      }).observe(strip);
    })();
  }

  function init() {
    initVideos();
    initStrips();
  }

  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
